






































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { getAllTerapeutasServer, Iterapeuta } from '@/plugins/utils/terapeutasUtils';
import { checkAdmin, checkDoc, checkRecepcao, copyArrayJson, GenerateFriendlyName } from '@/plugins/utils/utils';

@Component({
  components: {
    TitleArea
  }
})
export default class Terapeutas extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: true,
      value: 'telefone',
    },
    {
      text: "Mapa",
      align: 'center',
      sortable: true,
      value: 'mapa',
    },
    {
      text: "Timeline",
      align: 'center',
      sortable: true,
      value: 'timeline',
    },
  ];
  
  get itensPage(): number {
    if( !(this.$store.getters.userData && this.$store.getters.userData.itens_pag) ){
      return 10;
    }
    else{
      return this.$store.getters.userData.itens_pag;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  footerOptions: any = {
    "items-per-page-options": [this.itensPage, -1],
    "items-per-page-text": "Linhas/página",
    "items-per-page-all-text": "Todos"
  } 
  search = "";
  terapeutasList: Iterapeuta[] = [];
  terapeutas_loading = false;
  errorTerapeutas = false;

  get terapeutasListSearc(): Iterapeuta[]{
    return this.terapeutasList.filter(item => {
      if(!this.search || this.search.length < 3){
        return true;
      }
      else {
        const key_array: string[] = this.search.trim().split(" ");
        // console.log(key_array);
        let flag_found = 0;
        key_array.forEach(value => {
          const new_value: string = GenerateFriendlyName(value);
          if(!item.nome_pesquisa){
            item.nome_pesquisa = GenerateFriendlyName(item.nome);
          }
          
          if(
            (item.nome_pesquisa && item.nome_pesquisa.includes(new_value)) ||
            (item.telefone && item.telefone.includes(value))
          ){
            flag_found++;
          }

        });

        if(flag_found > 0 && flag_found == key_array.length){
          return true;
        }
        else {
          return false;
        }
      }
    });
  }
  
  created() {
    this.terapeutas_loading = true;
    this.errorTerapeutas = false;
    this.terapeutasList = [];
    getAllTerapeutasServer(
      (terapeutas: Iterapeuta[]) => {
        // console.log("u",utentes)
        this.terapeutasList = copyArrayJson(terapeutas);
        this.terapeutas_loading = false;
        this.$store.commit("setLoading", false);
      },
      () => {
        this.terapeutas_loading = false;
        this.$store.commit("setLoading", false);
        // console.log("err",code);
      }
    )
  }


  get checkAdmin(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkAdmin(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkRecepcao(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkRecepcao(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkDoc(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkDoc(this.$store.getters.userData.nivel);
    else
      return false;
  }
}
